import { isoZ, z } from 'my-zod'

export const payoutLineTypeOptions = [
  'charge',
  'chargeFee',
  'refund',
  'refundFee',
  'transfer',
  'transferReversal',
  'otherFee',
  'manualPayout'
] as const
export type PayoutLineType = (typeof payoutLineTypeOptions)[number]
export const payoutLineView = z.object({
  payoutId: z.string(),
  type: z.enum(payoutLineTypeOptions),
  source: z.string(),
  destination: z.string(),
  amount: z.number().int(),
  stripeId: z.string(),
  description: z.string(),
  associatedTransferGroup: z.string().nullable(),
  payoutCreatedDate: isoZ.instant(),
  balanceTransactionId: z.string()
})

export type payoutLineView = z.infer<typeof payoutLineView>
